import { render, staticRenderFns } from "./CostMaterialTransportationForm.vue?vue&type=template&id=3f40407c"
import script from "./CostMaterialTransportationForm.vue?vue&type=script&lang=js"
export * from "./CostMaterialTransportationForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports